import React, { useCallback, useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { BreadCrumbSecttion } from "../component/BreadCrumbSecttion";
import PrimaryGradientButton from "../component/PrimaryGradientButton";
import SelectDropDown from "../component/SelectDropDown";
import InputField from "../component/InputField";
import Form from "react-bootstrap/Form";
import OtherService from "../services/Other";
import { useParams } from "react-router-dom";
import RegistrationService from "../services/registration";
import AlertMsg from "../component/AlertMsg";
import { useNavigate } from "react-router-dom";
import Loader from "../component/Loader";
import AdminLayout from '../component/AdminLayout'
const EventEdit = () => {
  // All Use State
  const [loading, setLoading] = useState(true);
  const [isButtonLoading, setIsButtonLoading] = useState(false);
  //Alert Box
  const [isEditSuccess, setIsEditSuccess] = useState({
    isSuccess: true,
    heading: "",
    text: "",
  });
  const [showAlert, setShowAlert] = useState(false);
  //Date Format Change
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    let dd = date.getDate();
    let mm = parseInt(date.getMonth());
    let yyyy = date.getFullYear();
    mm++;
    mm += "";
    dd += "";
    if (mm.length < 2) mm = "0" + mm;
    if (dd.length < 2) dd = "0" + dd;

    return `${yyyy}-${mm}-${dd}`;
  };
  //Hierarchies
  const [isHierarchiesList, setIsHierarchiesList] = useState([]);
  const [isHierarchies, setIsHierarchies] = useState({ id: "", title: "" });
  //Contents
  const [isContentList, setIsContentList] = useState([]);
  const [isContents, setIsContents] = useState({ id: "", title: "" });
  const [isContentType, setIsContentType] = useState({ id: "", title: "" });
  //Country
  const [isCountryList, setIsCountryList] = useState([]);
  const [contentCountry, setContentCountry] = useState({ id: "", title: "" });
  //State
  const [isStateList, setIsStateList] = useState([]);
  const [contentState, setContentState] = useState({ id: "", title: "" });
  //City
  const [isCityList, setIsCityList] = useState([]);
  const [contentCity, setContentCity] = useState({ id: "", title: "" });
  const [contentActive, setContentActive] = useState({ id: " ", title: "" });
  const [isSingleDay, setIsSingleDay] = useState({ id: "", title: "" });
  //Input Fields Value Set//

  // Name validator
  const [isNameInvalid, setIsNameInvalid]=useState(false)  
  // description validator
  const [isDescriptionInvalid, setIsDescriptionInvalid]=useState(false) 
  // Short code validator
  const [isShortCodeInvalid, setIsShortCodeInvalid]=useState(false)
  // start date validator
  const [isStartDateInvalid, setIsStartDateInvalid]=useState(false)
  // end date validator
  const [isEndDateInvalid, setIsEndDateInvalid]=useState(false)

   

  const [eventInfo, setEventInfo] = useState({
    name: "",
    description: "",
    type: "",
    short_code: "",
    start_date: "",
    end_date: "",
    single_day: "",
    cog_countries_id: "",
    cog_states_id: "",
    cog_cities_id: "",
    is_active: "",
  });
  //All UseEffect
  useEffect(() => {
    const fetchContentData = async () => {
      try {
        // Content List
        const contentResponse = await OtherService.contentList();
        const contentListOptions = contentResponse.response.contentsList.map(
          (item) => ({
            id: item.contentId,
            title: item.contentTitle,
          })
        );

        setIsContentList(contentListOptions);
        //Hierarchies List
        const hierarchiesResponse = await OtherService.hierarchiesList();
        const hierarchiesListOptions =
          hierarchiesResponse.response.hierarchiesDetails.map((item) => ({
            id: item.hireId,
            title: item.title,
          }));
        setIsHierarchiesList(hierarchiesListOptions);
      } catch (error) {
        console.error("Content List Data Error");
      }
    };
    fetchContentData();
  }, []);
  //All Countries
  useEffect(() => {
    const fetchCountryData = async () => {
      try {
        const response = await RegistrationService.allCountries();
        const countryNames = response.response.countriesDetails.map(
          (country) => ({
            id: country.id,
            title: country.name,
          })
        );

        setIsCountryList(countryNames);
      } catch (error) {
        console.error("Error fetching country data:");
      }
    };
    fetchCountryData();
  }, []);
  //All States

  useEffect(() => {
    const stateListFetch = async () => {
      if (contentCountry.id) {
        try {
          const stateListResponse = await RegistrationService.allStates(
            contentCountry.id
          );
          if (stateListResponse) {
            const statesDetails = stateListResponse.response.statesDetails;
            if (statesDetails.length > 0) {
              let array = [];
              for (let i = 0; i < statesDetails.length; i++) {
                array.push({
                  id: statesDetails[i].id,
                  title: statesDetails[i].name,
                });
              }
              setIsStateList(array);
              displayStateName(array);
            }
          } else {
            console.error("test:");
          }
        } catch (error) {
          console.error("Error:");
        }
      }
    };

    stateListFetch();
  }, [contentCountry.id]);

  //All City
  useEffect(() => {
    const fetchCityList = async () => {
      if (contentCountry.id && contentState.id) {
        try {
          const cityListResponse = await RegistrationService.allCities(
            contentCountry.id,
            contentState.id
          );

          if (cityListResponse.response.citiesDetails.length > 0) {
            let array = [];
            for (
              let i = 0;
              i < cityListResponse.response.citiesDetails.length;
              i++
            ) {
              array.push({
                id: cityListResponse.response.citiesDetails[i].id,
                title: cityListResponse.response.citiesDetails[i].name,
              });
            }
            setIsCityList(array);
            displayCityName(array);
          }
        } catch (error) {
          console.error("Error");
        }
      }
    };
    fetchCityList();
  }, [contentCountry.id, contentState.id]);

  const { eventId } = useParams();
  //API Call for data display
  useEffect(() => {
    async function eventInf() {
      const token = localStorage.getItem("access_token");
      const responseEventFormData = await OtherService.eventListById(
        token,
        eventId
      );
      setStartDate(formatDate(responseEventFormData.data[0].start_date));
      setEndDate(formatDate(responseEventFormData.data[0].end_date));
      setEventInfo(responseEventFormData.data[0]);
      setLoading(false);
      //Country Name
      const selectedCountryId = responseEventFormData.data[0].cog_countries_id;
      for (let i = 0; i < isCountryList.length; i++) {
        if (isCountryList[i].id == selectedCountryId) {
          setContentCountry({
            id: isCountryList[i].id,
            title: isCountryList[i].title,
          });
        }
      }
    }
    eventInf();
  }, [isCountryList]);

  //  City Name
  function displayCityName(cityList) {
    const selectedCityId = eventInfo.cog_cities_id;
    for (let i = 0; i < cityList.length; i++) {
      if (cityList[i].id == selectedCityId) {
        setContentCity({ id: cityList[i].id, title: cityList[i].title });
      }
    }
  }
  //  STATE Name
  function displayStateName(nameList) {
    const selectedStateId = eventInfo.cog_states_id;
    for (let i = 0; i < nameList.length; i++) {
      if (nameList[i].id == selectedStateId) {
        setContentState({ id: nameList[i].id, title: nameList[i].title });
      }
    }
  }

  useEffect(() => {
    const eventFormDataFetch = async () => {
      try {
        // Hierarchies
        const hierarchiesId = eventInfo.dcm_hierarchies_id;
        const hierarchiesTitle = isHierarchiesList.filter(
          (hierarchieslist) => hierarchieslist.id == hierarchiesId
        );
        if (hierarchiesTitle.length > 0) {
          setIsHierarchies({
            id: hierarchiesId,
            title: hierarchiesTitle[0].title,
          });
        }

        // CONTENT
        // setIsContents
        const contentId = eventInfo.dcm_contents_id;
        const contents = isContentList.filter((obj) => obj.id == contentId);
        if (contents.length > 0) {
          setIsContents({
            id: contents[0].id,
            title: contents[0].title,
          });
        }
        //ContentType

        if (eventInfo.type == "event") {
          setIsContentType({
            id: "1",
            title: "Event",
          });
        } else {
          setIsContentType({
            id: "0",
            title: "Campaign",
          });
        }
        //Single Day
        if (eventInfo.single_day == "1") {
          setIsSingleDay({
            id: "1",
            title: "Yes",
          });
        } else {
          setIsSingleDay({
            id: "0",
            title: "No",
          });
        }

        //Active

        if (eventInfo.is_active == "1") {
          setContentActive({
            id: "1",
            title: "Yes",
          });
        } else {
          setContentActive({
            id: "0",
            title: "No",
          });
        }
      } catch (e) {
        console.error("Error");
      }
    };
    eventFormDataFetch(eventId);
  }, [isCountryList, isStateList, isCityList, eventInfo]);
  //Show Date Function
  const showDate = useCallback((e) => {
    setStartDate(e.target.value); 
    if(e.target.value==""){
      setIsStartDateInvalid(true) 
    }else{
      setIsStartDateInvalid(false) 
    }
    

  }, []);

  const showEndDate = useCallback((e) => {
    setEndDate(e.target.value);
    if(e.target.value==""){
      setIsEndDateInvalid(true) 
    }else{
      setIsEndDateInvalid(false) 
    }
  }, []);

  //EVENT EDIT ALL FUNCTIONS//
  const handleNameChange = (e) => {
    setEventInfo({
      ...eventInfo,
      name: e.target.value,
    });
    if(e.target.value==""){
      setIsNameInvalid(true)
    }else{
      setIsNameInvalid(false)
    }
    
  };
  const handleDescriptionChange = (e) => {
    setEventInfo({
      ...eventInfo,
      description: e.target.value,
    });

    if(e.target.value==""){
      setIsDescriptionInvalid(true)
    }else{
      setIsDescriptionInvalid(false)
    }
  };
  const handleShortCodeChange = (e) => {
    setEventInfo({
      ...eventInfo,
      short_code: e.target.value,
    });

    if(e.target.value==""){
      setIsShortCodeInvalid(true)
    }else{
      setIsShortCodeInvalid(false)
    }
  };
  //Event Edit API
  const handleEditEvent = () => {

    const token = localStorage.getItem("access_token");
    const payload = {
      eventId: eventId,
      hierarchyId: isHierarchies.id,
      name: eventInfo.name,
      contents_id: isContents.id,
      programs_id: isContentType.id,
      description: eventInfo.description,
      type: isContentType.title,
      short_code: eventInfo.short_code,
      start_date: startDate,
      end_date: endDate,
      single_day: isSingleDay.id,
      cog_countries_id: contentCountry.id,
      cog_states_id: contentState.id,
      cog_cities_id: contentCity.id,
      is_active: contentActive.id,
    };
    
    setIsButtonLoading(true); 

    if(isNameInvalid||isDescriptionInvalid||isShortCodeInvalid){
      setShowAlert(true);
      setIsEditSuccess({ isSuccess: false, text: "Invalid Data" });
      setIsButtonLoading(false);
    }
    else if(isStartDateInvalid||isEndDateInvalid){
      setIsButtonLoading(false);
      setShowAlert(true);
      setIsEditSuccess({ isSuccess: false, text: "Invalid Date" });
    }
    else if(new Date(payload.start_date)>new Date(payload.end_date)){      
      setIsButtonLoading(false);
      setShowAlert(true);
      setIsEditSuccess({ isSuccess: false, text: "End date must come after start date" });
    }    
    else{      
      OtherService.eventEdit(payload, token)
      .then((res) => {
        if (!res.error) {
          setShowAlert(true);
          setIsEditSuccess({ isSuccess: true, text: res.apiResponse });
          setTimeout(() => {
            navigate("/event-list");
          }, 2000);
        }
      })
      .catch((e) => {
      });
    }
    
  };
  const navigate = useNavigate();
  //All FunctionssetIsContentType
  const handleHierarchiesChange = (selectedValue) => {
    setIsHierarchies(selectedValue);
  };
  const handleContentTypeChange = (selectedValue) => {
    setIsContentType(selectedValue);
  };

  const handleContentCountryNameChange = (selectedValue) => {
    setContentCountry(selectedValue);
  };

  const handleContentStateNameChange = (selectedValue) => {
    setContentState(selectedValue);
  };

  const handleContentCityNameChange = (selectedValue) => {
    setContentCity(selectedValue);
  };
  //All Functions
  const handleContentChange = (selectedValue) => {
    setIsContents(selectedValue);
  };

  //Type
  const ContentType = [
    {
      id: "1",
      title: "Event",
    },
    {
      id: "2",
      title: "Campaign",
    },
  ];

  //Single Day
  const singleDay = [
    {
      id: "1",
      title: "Yes",
    },
    {
      id: "0",
      title: "No",
    },
  ];
  //Active

  const contentActiveList = [
    {
      id: "1",
      title: "Yes",
    },
    {
      id: "0",
      title: "No",
    },
  ];

  const handleActiveChange = (selectedValue) => {
    setContentActive(selectedValue.id);
  };

  const handleSingleDayChange = (selectedValue) => {
    setIsSingleDay(selectedValue);
  };

  //Content List, //Hierarchies List

  return (
    <>
    <AdminLayout>
      {loading && <Loader />}

      {/* <BreadCrumbSecttion pageTitle="Edit Event" currentPageName="Edit Event" /> */}
      <section className="padTop50">
        <Container>
          <Row className="justify-content-center align-item-center h-100">
            <Col xs={12}>
              <div className="userInfoBox">
                <div className="dashboard-title">
                  <h4>Please Edit Your Event</h4>
                </div>
                <div className="dashboard-details">
                  <Row>
                    <Col xs={12} lg={3}>
                      <SelectDropDown
                        labelName="Hierarchies"
                        requiredStar="*"
                        options={isHierarchiesList}
                        setSelectedValue={setIsHierarchies}
                        selectedValue={isHierarchies}
                        onChange={handleHierarchiesChange}
                      />
                    </Col>
                    <Col xs={12} lg={3}>
                      <SelectDropDown
                        labelName="Contents"
                        requiredStar="*"
                        options={isContentList}
                        setSelectedValue={setIsContents}
                        selectedValue={isContents}
                        onChange={handleContentChange}
                      />
                    </Col>
                    <Col xs={12} lg={3}>
                      <InputField
                        requiredStar="*"
                        inputFieldLabel="Name"
                        name="name"
                        value={eventInfo.name}
                        onChange={handleNameChange}
                      />
                      {isNameInvalid && (
                        <div className="error-message mt-1">
                          {"Name is invalid"}
                        </div>
                      )}
                    </Col>
                    <Col xs={12} lg={3}>
                      <InputField
                        requiredStar="*"
                        inputFieldLabel="Description"
                        name="description"
                        value={eventInfo.description}
                        onChange={handleDescriptionChange}
                      />
                      {isDescriptionInvalid && (
                        <div className="error-message mt-1">
                          {"Description is invalid"}
                        </div>
                      )}
                    </Col>
                    <Col xs={12} lg={3}>
                      <SelectDropDown
                        labelName="Type"
                        requiredStar="*"
                        options={ContentType}
                        setSelectedValue={setIsContentType}
                        selectedValue={isContentType}
                        onChange={handleContentTypeChange}
                      />
                    </Col>
                    <Col xs={12} lg={3}>
                      <InputField
                        requiredStar="*"
                        inputFieldLabel="Shortcode"
                        name="short_code"
                        value={eventInfo.short_code}
                        onChange={handleShortCodeChange}
                      />
                      {isShortCodeInvalid && (
                        <div className="error-message mt-1">
                          {"Short code is invalid"}
                        </div>
                      )}
                    </Col>
                    <Col xs={12} lg={3}>
                      <Form.Label>
                        Start Date <span className="redStar">*</span>
                      </Form.Label>
                      <Form.Control
                        type="date"
                        name="startDate"
                        value={startDate}
                        onChange={showDate}
                      />
                      {isStartDateInvalid && (
                        <div className="error-message mt-1">
                          {"Date is invalid"}
                        </div>
                      )}
                    </Col>
                    <Col xs={12} lg={3}>
                      <Form.Label>
                        End Date <span className="redStar">*</span>
                      </Form.Label>
                      <Form.Control
                        type="date"
                        name="endDate"
                        value={endDate}
                        onChange={showEndDate}
                        // value={eventInfo.end_date}
                      />
                      {isEndDateInvalid && (
                        <div className="error-message mt-1">
                          {"Date is invalid"}
                        </div>
                      )}
                    </Col>
                    <Col xs={12} lg={3}>
                      <SelectDropDown
                        labelName="Single Day"
                        requiredStar="*"
                        options={singleDay}
                        setSelectedValue={setIsSingleDay}
                        selectedValue={isSingleDay}
                        onChange={handleSingleDayChange}
                      />
                    </Col>
                    <Col xs={12} lg={3}>
                      <SelectDropDown
                        labelName="Country"
                        requiredStar="*"
                        options={isCountryList}
                        setSelectedValue={setContentCountry}
                        selectedValue={contentCountry}
                        onChange={handleContentCountryNameChange}
                      />
                    </Col>
                    <Col xs={12} lg={3}>
                      <SelectDropDown
                        labelName="State"
                        requiredStar="*"
                        options={isStateList}
                        setSelectedValue={setContentState}
                        selectedValue={contentState}
                        onChange={handleContentStateNameChange}
                      />
                    </Col>
                    <Col xs={12} lg={3}>
                      <SelectDropDown
                        labelName="City"
                        requiredStar="*"
                        options={isCityList}
                        setSelectedValue={setContentCity}
                        selectedValue={contentCity}
                        onChange={handleContentCityNameChange}
                      />
                    </Col>
                    <Col xs={12} lg={3}>
                      <SelectDropDown
                        labelName="Active"
                        options={contentActiveList}
                        setSelectedValue={setContentActive}
                        selectedValue={contentActive}
                        onChange={handleActiveChange}
                        requiredStar="*"
                      />
                    </Col>
                    <Col xs={12} lg={3}>
                      <PrimaryGradientButton
                        buttonText={
                          isButtonLoading ? "Processing..." : "Submit"
                        }
                        className="mt-28"
                        onClick={handleEditEvent}
                        disabled={isButtonLoading}
                      />
                    </Col>
                    <Col xs={12} lg={6}></Col>
                    <Col xs={12} lg={6}>
                      {showAlert && (
                        <AlertMsg
                          alertBoxColor={
                            isEditSuccess.isSuccess
                              ? "successAlert"
                              : "FailedAlert"
                          }
                          heading={isEditSuccess.heading}
                          text={isEditSuccess.text}
                        />
                      )}
                    </Col>
                  </Row>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      </AdminLayout>
    </>
  );
};

export default EventEdit;
